import {Directive, ElementRef, OnInit} from '@angular/core';
import {addClassName, removeClassName} from "../../../utils/dom-helpers";
import {I18nPipe} from "../../../i18n/i18n.pipe";

declare var $: any;

@Directive({
  selector: '[select2]'
})
export class Select2Directive implements OnInit {

    constructor(private el: ElementRef,
                private i18n: I18nPipe) {
        addClassName(this.el.nativeElement, ['sa-cloak', 'sa-hidden'])
    }

    private options: any = {};

    ngOnInit() {
        if (!!$(this.el.nativeElement).find("option[disabled]").get(0)) {
            if (!!this.i18n.i18nService.data) {
                this.options.placeholder = this.i18n.transform($(this.el.nativeElement).find("option[disabled]").get(0).text);
                this.loadSelect2();
            } else {
                this.i18n.i18nService.subscribe(() => {
                    this.options.placeholder = this.i18n.transform($(this.el.nativeElement).find("option[disabled]").get(0).text);
                    this.loadSelect2();
                }, () => this.loadSelect2());
            }
        }
    }

    loadSelect2() {
        System.import('script-loader!select2/dist/js/select2.min.js').then(() => {
            if (this.el.nativeElement.hasAttribute('hide-search')) {
                this.options.minimumResultsForSearch = -1;
                $(this.el.nativeElement).select2(this.options)
            } else
                $(this.el.nativeElement).select2(this.options)
            removeClassName(this.el.nativeElement, ['sa-hidden'])
        })
    }

}
